export default {"src":"/_next/static/media/hide-small-icon-mobile.dc799c98.svg","height":11,"width":14};